import { SCOPE_CURRENCY_SET } from "constants/action-types";
import "rxjs/add/operator/map";
import me from "models/me";
import { clearInsightsData } from "actions/insights-actions";

export const updateCurrencyEpic = (action$, store) =>
    action$.ofType(SCOPE_CURRENCY_SET).mergeMap((action) => {
        const state = store.getState();

        if (!state.ldFlags.orderInsightsNu64953 || !me.hasPermission("order_trends")) {
            return [];
        }

        if (action.payload.toLowerCase() !== "usd") {
            return [clearInsightsData()];
        }

        return [];
    });
